export const ru = {
  meta: {
    title: 'AuthFlow™ - простая аутентификация по email и паролю с JWT-токенами',
    description: 'Надёжная аутентификация по email и паролю с JWT-токенами для современных веб-приложений. В отличие от сложных платформ, мы делаем ставку на то, что работает: безопасный и простой вход, которому доверяют разработчики.',
  },
  // Navigation
  nav: {
    home: 'Главная',
    features: 'Функции',
    pricing: 'Цены',
    compare: 'Сравнение',
    contact: 'Контакты',
    getStarted: 'Начать',
    signIn: 'Войти',
  },

  // Dashboard
  dashboard: {
    title: 'Панель управления',
    users: 'Пользователи',
    activity: 'Активность',
    settings: 'Настройки',
    logout: 'Выйти',
    profileSettings: 'Настройки профиля',
    activityLog: 'Журнал активности',
    welcome: 'Добро пожаловать в вашу панель управления',
    welcomeBack: 'Добро пожаловать обратно, {name}. Вот что происходит с вашим сервисом аутентификации.',
    hereIsWhatsHappening: 'Вот что происходит с вашим сервисом аутентификации.',
    totalUsers: 'Всего пользователей',
    activeUsers: 'Активные пользователи',
    totalLogins: 'Всего входов',
    recentActivity: 'Недавняя активность',
    noRecentActivity: 'Нет недавней активности',
    userSettings: 'Настройки пользователя',
    organizationOwnerCannotBeManaged: 'Владелец организации не может управляться',
    configureSettings: 'Настроить параметры',
    fromLastMonth: 'с прошлого месяца',
    monthlyLogins: 'Месячные входы',
    successRate: 'Уровень успеха',
    latestAuthEvents: 'Последние события аутентификации и обновления системы',
    viewAllActivity: 'Просмотреть всю активность',
    userManagement: 'Управление пользователями',
    manageApplicationUsers: 'Управляйте пользователями вашего приложения',
    viewAllUsers: 'Просмотреть всех пользователей',
    apiKeys: 'API-ключи',
    manageApiKeys: 'Управляйте ключами API аутентификации',
    systemStatus: 'Статус системы',
    authenticationApi: 'API аутентификации',
    operational: 'Работает',
    userManagementService: 'Сервис управления пользователями',
    searchUsers: 'Поиск пользователей...',
    all: 'Все',
    active: 'Активные',
    inactive: 'Неактивные',
    lastLogin: 'Последний вход',
    never: 'Никогда',
    admin: 'Админ',
    owner: 'Владелец',
    noUsersFound: 'Пользователи, соответствующие вашим критериям, не найдены',
    noUsers: 'Пользователи не найдены',
    for: 'для',
    noApiKeyFound: 'API-ключ не найден',
    hideApiKey: 'Скрыть API-ключ',
    showApiKey: 'Показать API-ключ',
    created: 'Создано',
    success: 'Успех',
    warning: 'Предупреждение',
    info: 'Информация',
    system: 'Система',
    justNow: 'только что',
    minutesAgo: 'минут назад',
    hoursAgo: 'часов назад',
    daysAgo: 'дней назад',
    notifications: 'Уведомления',
    billingReminder: 'Напоминание о счете',
    noNewNotifications: 'Нет новых уведомлений',
    logOut: 'Выйти',
  },

  // Hero Section
  hero: {
    badge: 'Доверяют более 10 000 разработчиков',
    title: 'Аутентификация по Email/Паролю',
    subtitle: 'Сделано Правильно',
    description: 'Простой, надежный вход по email и паролю с JWT токенами. В отличие от сложных платформ аутентификации, мы сосредотачиваемся на том, что важно: безопасная аутентификация, которая просто работает.',
    startTrial: 'Начать Бесплатный Тест',
    getStarted: 'Начать',
    trialNote: 'Без кредитной карты • 10 ежемесячных активных пользователей бесплатно',
    metrics: {
      firstIntegrationValue: '5 мин',
      firstIntegrationLabel: 'до первой интеграции',
      predictableSessionsValue: 'JWT',
      predictableSessionsLabel: 'предсказуемые сессии',
      noMazeValue: 'Без лабиринта',
      noMazeLabel: 'для команд, которым нужен просто рабочий auth',
    },
    missionControlLabel: 'Центр управления auth',
    missionControlTitle: 'Аутентификация пользователей без лабиринта',
    missionControlStatus: 'Стабильно',
    sessionLayer: 'Слой сессий',
    emailPasswordSignIn: 'Вход по email/паролю',
    roleAwareVerification: 'Проверка с учетом роли',
    validated: 'проверено',
    live: 'в работе',
    integrationShapeLabel: 'Форма интеграции',
    integrationShapeValue: 'Небольшой API, понятный поток',
    forTeamsLabel: 'Для команд',
    forTeamsValue: 'Делайте продукт, а не IAM-проекты',
  },

  // Features
  features: {
    title: 'Почему AuthFlow™ отличается',
    description: 'Мы сосредотачиваемся на аутентификации по email/паролю с JWT токенами - фундаменте безопасных веб-приложений. В отличие от платформ, которые пытаются делать всё, мы делаем одно дело исключительно хорошо.',
    emailPassword: {
      title: 'Вход по Email/Паролю',
      description: 'Простая, безопасная аутентификация по email и паролю, которая работает надежно. Без сложных потоков или ненужных функций - просто вход, который понимают ваши пользователи.',
    },
    jwtTokens: {
      title: 'Управление JWT Токенами',
      description: 'Правильная обработка JWT токенов для сессий, с безопасным хранением и автоматическим обновлением. Стандартные токены отрасли, которые легко интегрируются с вашим API.',
    },
    developerApi: {
      title: 'API для Разработчиков',
      description: 'RESTful API с полной документацией, SDK и инструментами разработчика. Создано разработчиками для DevSecOps рабочего процесса.',
    },
  },

  // Testimonials
  testimonials: {
    title: 'Доверяют разработчики по всему миру',
    testimonial1: {
      text: 'AuthFlow™ сэкономил нам месяцы разработки. Интеграция была бесшовной, а функции безопасности - корпоративного уровня.',
      author: 'Сара Джонсон',
      role: 'CTO, TechStart',
    },
    testimonial2: {
      text: 'Панель аналитики дает нам невероятные insights о поведении пользователей. Лучшее решение аутентификации, которое мы использовали.',
      author: 'Майк Родригес',
      role: 'Ведущий Разработчик, AppCorp',
    },
    testimonial3: {
      text: 'Каменная надежность и отличная поддержка. Нашим пользователям нравится плавный опыт аутентификации.',
      author: 'Алекс Лю',
      role: 'Менеджер Продукта, InnovateLab',
    },
  },

  // CTA Section
  cta: {
    title: 'Готовы добавить надежную аутентификацию?',
    description: 'Присоединяйтесь к разработчикам, которые выбирают простую, эффективную аутентификацию по email/паролю с JWT токенами. Начните бесплатный тест сегодня.',
    startTrial: 'Начать Бесплатный Тест',
  },

  // About Page
  about: {
    title: 'О AuthFlow™ - Эксперты по Простой Аутентификации Email/Пароль',
    description: 'Узнайте о миссии AuthFlow™ по предоставлению надежной аутентификации по email/паролю с JWT токенами. Основана в 2023 году, мы делаем безопасный вход простым для каждого разработчика.',
    keywords: [
      'аутентификация по email паролю',
      'компания JWT аутентификации',
      'эксперты аутентификации',
      'простая аутентификация',
      'компания безопасного входа',
      'аутентификация разработчика',
      'надежная аутентификация',
      'аутентификация на основе токенов',
      'безопасность веб-приложений',
      'платформа аутентификации'
    ],
    ogTitle: 'О AuthFlow™ - Эксперты по Простой Аутентификации Email/Пароль',
    ogDescription: 'Узнайте о нашей миссии по предоставлению надежной аутентификации по email/паролю с JWT токенами. В отличие от сложных платформ, мы сосредотачиваемся на том, что работает.',
    hero: {
      badge: 'Основана в 2023',
      title: 'Строим Будущее',
      titleAccent: 'Простой Аутентификации',
      description: 'Наша миссия - сделать аутентификацию по email/паролю с JWT токенами доступной для каждого разработчика, устраняя сложности и риски безопасности при самостоятельной разработке аутентификации.',
    },
    mission: {
      title: 'Наша Миссия',
      description1: 'Демократизировать безопасную аутентификацию на основе токенов, которая проста в реализации и поддержке. Мы верим, что каждое приложение заслуживает простой, надежной аутентификации по email/паролю с JWT токенами, без головной боли от чрезмерно сложных платформ.',
      description2: 'Мы уделяем приоритетное внимание приватности и соответствию требованиям по дизайну — минимизируя сбор данных, шифруя конфиденциальную информацию при хранении и передаче, и предлагая настраиваемые политики хранения. Наша цель — помочь командам соответствовать нормативным требованиям без ущерба для удобства использования и скорости разработки.',
      description3: 'Абстрагируя сложности чрезмерно сложных протоколов безопасности, безопасности через obscurity и управления пользователями, мы позволяем разработчикам сосредоточиться на том, что они умеют делать лучше всего: создавать потрясающие продукты с надежной аутентификацией.',
    },
    vision: {
      title: 'Наше Видение',
      description1: 'Мир, где аутентификация проста и надежна. Мы представляем будущее, где каждое веб-приложение имеет доступ к надежной аутентификации по email/паролю с JWT токенами, без сложности и ненадежности чрезмерно сложных платформ.',
      description2: 'Через непрерывные инновации и развитие, управляемое сообществом, мы строим инфраструктуру аутентификации, которая сосредотачивается на том, что важно: безопасный, простой вход, на который разработчики могут положиться.',
    },
    values: {
      title: 'Наши Ценности',
      subtitle: 'Принципы, которые направляют все, что мы делаем в AuthFlow™.',
      reliableSecurity: {
        title: 'Надежная Безопасность',
        description: 'Мы сосредотачиваемся на проверенных практиках безопасности, которые работают. Аутентификация по email/паролю с правильным управлением JWT токенами — без ненужной сложности.',
      },
      developerFirst: {
        title: 'API для Разработчиков Прежде Всего',
        description: 'Мы одержимы тем, чтобы сделать наш инструмент интуитивным, хорошо документированным и приятным в использовании. Отличный опыт разработчика приводит к лучшим продуктам, разработанным разработчиками, с безопасной аутентификацией.',
      },
      communityDriven: {
        title: 'Управляемое Сообществом',
        description: 'Наша дорожная карта формируется вами, разработчиком-клиентом. Мы слушаем, учимся и строим на основе реальных потребностей безопасности.',
      },
    },
    team: {
      title: 'Познакомьтесь с Нашей Командой',
      subtitle: 'Страстные люди, строящие будущее аутентификации.',
      alex: {
        initials: 'AJ',
        name: 'Алекс Джонсон',
        role: 'CEO и Со-основатель',
        bio: 'Бывший DevSecOps в крупной американской многонациональной финансовой корпорации. Страстно относится к тому, чтобы сделать надежную аутентификацию по email/паролю доступной для всех разработчиков.',
      },
      sarah: {
        initials: 'SC',
        name: 'Сара Чен',
        role: 'CTO и Со-основатель',
        bio: 'Архитектор полного стека с более чем 10-летним опытом создания надежных систем аутентификации. Эксперт в аутентификации по email/паролю и управлении JWT токенами.',
      },
      marcus: {
        initials: 'MR',
        name: 'Маркус Родригес',
        role: 'Глава Продукта',
        bio: 'Лидер продукта, сосредоточенный на опыте разработчика и надежной аутентификации. Эксперт в простых, эффективных системах входа по email/паролю.',
      },
    },
    stats: {
      title: 'AuthFlow™ в Цифрах',
      developers: 'Разработчики Доверяют Нам',
      authentications: 'Ежемесячных Аутентификаций',
      uptime: 'Время Работы',
      monitoring: 'Мониторинг Безопасности',
    },
    cta: {
      title: 'Присоединяйтесь к Нашей Миссии',
      description: 'Готовы стать частью революции аутентификации? Начните создавать с надежной аутентификацией по email/паролю сегодня.',
      getStarted: 'Начать Бесплатно',
      contactUs: 'Связаться с Нами',
    },
    breadcrumb: {
      company: 'Компания',
      aboutUs: 'О Нас',
    },
  },

  // Sign In Page
  signIn: {
    title: 'Добро пожаловать обратно',
    subtitle: 'Войдите в свою аутентификацию по email/паролю',
    card: {
      title: 'Вход для Организации',
      description: 'Введите email владельца организации для доступа к панели управления JWT аутентификацией',
    },
    form: {
      email: {
        label: 'Email',
        placeholder: 'owner@yourorganization.com',
      },
      password: {
        label: 'Пароль',
        placeholder: 'Введите ваш пароль',
      },
      signIn: 'Войти',
      signingIn: 'Вход...',
      noAccount: {
        text: 'Нет организации?',
        link: 'Создать',
      },
    },
    errors: {
      emailRequired: 'Email обязателен',
      failed: 'Не удалось войти',
      unexpected: 'Произошла непредвиденная ошибка. Пожалуйста, попробуйте еще раз.',
    },
    success: {
      message: 'Успешный вход!',
    },
    agreement: {
      text: 'Входя в систему, вы соглашаетесь с нашими',
      terms: 'Условиями Использования',
      and: 'и',
      privacy: 'Политикой Конфиденциальности',
    },
  },

  // Sign Up
  signUp: {
    title: 'Создайте свою организацию',
    subtitle: 'Начните свою организацию с аутентификацией по email/паролю',
    card: {
      title: 'Создать Организацию',
      description: 'Настройте свою организацию для начала работы с аутентификацией по email/паролю и JWT токенами',
    },
    form: {
      organizationName: {
        label: 'Название Организации',
        placeholder: 'Ваша Организация',
      },
      organizationWebsite: {
        label: 'Сайт организации',
        placeholder: 'yourorganization.com',
      },
      emailOwner: {
        label: 'Email Владельца',
        placeholder: 'owner@yourorganization.com',
      },
      password: {
        label: 'Пароль',
        placeholder: 'Создайте надежный пароль',
      },
      confirmPassword: {
        label: 'Подтвердите пароль',
        placeholder: 'Подтвердите ваш пароль',
      },
      agreeToTerms: 'Я согласен с Условиями Использования и Политикой Конфиденциальности',
      acceptMarketing: 'Присылайте мне обновления продукта и маркетинговые emails',
      createOrganization: 'Создать организацию',
      creatingOrganization: 'Создание организации...',
      haveAccount: {
        text: 'Уже есть аккаунт?',
        link: 'Войти',
      },
    },
    errors: {
      organizationNameRequired: 'Название организации обязательно',
      organizationWebsiteRequired: 'Сайт организации обязателен',
      emailRequired: 'Email обязателен',
      passwordRequired: 'Пароль обязателен',
      passwordsDoNotMatch: 'Пароли не совпадают',
      agreeToTermsRequired: 'Вы должны согласиться с Условиями Использования и Политикой Конфиденциальности',
      failed: 'Не удалось создать организацию',
      unexpected: 'Произошла непредвиденная ошибка. Пожалуйста, попробуйте еще раз.',
    },
    success: {
      message: 'Организация создана успешно!',
    },
    trial: {
      description: 'Начните управлять аутентификацией вашей организации сегодня.',
      features: {
        emailPassword: 'Аутентификация по email/паролю',
        jwtTokens: 'Безопасность JWT токенов',
        simpleLogin: 'Простой вход',
      },
    },
  },

  // Pricing Page
  pricing: {
    title: 'Цены AuthFlow™ - Простые Стоимости Аутентификации Email/Пароль',
    description: 'Простые, прозрачные цены на аутентификацию по email/паролю с JWT токенами. Начните бесплатно и масштабируйтесь по мере роста. Без скрытых платежей, надежные цены на аутентификацию.',
    keywords: [
      'цены аутентификации',
      'цены email пароля',
      'цены JWT',
      'цены простой аутентификации',
      'цены аутентификации разработчика',
      'надежные стоимости аутентификации',
      'цены безопасного входа',
      'цены аутентификации на основе токенов',
      'бесплатный тест аутентификации'
    ],
    ogTitle: 'Цены AuthFlow™ - Простые Стоимости Аутентификации Email/Пароль',
    ogDescription: 'Выберите идеальный план для ваших нужд. Начните бесплатно и масштабируйтесь по мере роста с надежной аутентификацией по email/паролю и JWT токенами.',
    hero: {
      title: 'Простые, прозрачные',
      titleAccent: 'цены аутентификации',
      description: 'Выберите идеальный план для ваших нужд аутентификации. Начните бесплатно и масштабируйтесь по мере роста с аутентификацией по email/паролю через JWT токены сессий. Без скрытых платежей, без сюрпризов.',
    },
    breadcrumb: {
      product: 'Продукт',
      pricing: 'Цены',
    },
    plans: {
      starter: {
        name: 'Стартовый',
        description: 'Идеально для небольших проектов и тестирования аутентификации по email/паролю',
        price: '$0',
        period: '/месяц',
        features: {
          users: 'До 10 активных пользователей в месяц',
          basicAuth: 'Базовая аутентификация по email/паролю',
          support: 'Стандартная поддержка',
        },
        cta: 'Начать Бесплатно',
      },
      pro: {
        name: 'Профессиональный',
        description: 'Для растущих бизнесов, нуждающихся в надежной аутентификации по email/паролю',
        price: '$9.99',
        period: 'первый месяц, затем $19.99/месяц',
        badge: 'Самый Популярный',
        features: {
          users: 'Неограниченное количество активных пользователей в месяц',
          advancedAuth: 'Расширенная аутентификация по email/паролю',
          support: 'Приоритетная поддержка',
        },
        cta: 'Начать Бесплатный Тест',
        monthlyCta: 'Купить месячный план',
        annualCta: 'Купить годовой план',
      },
    },
    faq: {
      title: 'Часто задаваемые вопросы',
      subtitle: 'Все, что вам нужно знать о наших ценах и планах аутентификации по email/паролю.',
      questions: {
        mau: {
          question: 'Что считается ежемесячным активным пользователем?',
          answer: 'Ежемесячный активный пользователь (MAU) - это уникальный пользователь, который аутентифицируется в вашем приложении хотя бы один раз в календарный месяц.',
        },
        changePlans: {
          question: 'Могу ли я изменить планы в любое время?',
          answer: 'Да, вы можете повысить или понизить свой план в любое время. Изменения вступают в силу немедленно, а биллинг рассчитывается пропорционально.',
        },
        freeTrial: {
          question: 'Есть ли бесплатный тест?',
          answer: 'Да, все платные планы поставляются с 14-дневным бесплатным тестом. Кредитная карта не требуется для начала.',
        },
        paymentMethods: {
          question: 'Какие способы оплаты вы принимаете?',
          answer: 'Мы принимаем все основные кредитные карты, Google Pay и Apple Pay.',
        },
      },
    },
    cta: {
      title: 'Готовы начать?',
      description: 'Присоединяйтесь к тысячам разработчиков, которые доверяют AuthFlow™ надежную аутентификацию по email/паролю. Начните свой бесплатный тест сегодня.',
      startTrial: 'Начать Бесплатный Тест',
      contactSales: 'Связаться с Продажами',
    },
    footer: {
      description: 'Простая, надежная аутентификация по email/паролю с JWT токенами. Доверяют разработчики по всему миру.',
      product: {
        title: 'Продукт',
        features: 'Функции',
        pricing: 'Цены',
        apiReference: 'API Справочник',
      },
      resources: {
        title: 'Ресурсы',
        gettingStarted: 'Начать',
        apiReference: 'API Справочник',
        support: 'Поддержка',
      },
      company: {
        title: 'Компания',
        about: 'О Нас',
        privacy: 'Политика Конфиденциальности',
        terms: 'Условия Использования',
      },
      copyright: '© 2024 AuthFlow™. Все права защищены.',
    },
  },

  // Get Started Page
  getStarted: {
    title: 'AuthFlow™ Начать - Руководство по Настройке Аутентификации Email/Пароль | Интеграция JWT API',
    description: 'Полное руководство по реализации аутентификации по email/паролю с AuthFlow™. Настройте JWT токены для безопасного входа за минуты. Удобный API для разработчиков для надежной аутентификации.',
    keywords: [
      'настройка аутентификации',
      'аутентификация email пароля',
      'интеграция JWT',
      'руководство безопасного входа',
      'аутентификация разработчика',
      'туториал API аутентификации',
      'аутентификация на основе токенов',
      'руководство API аутентификации'
    ],
    ogTitle: 'AuthFlow™ Начать - Руководство по Настройке Аутентификации Email/Пароль | Интеграция JWT API',
    ogDescription: 'Полное руководство по реализации аутентификации по email/паролю с AuthFlow™. Настройте JWT токены для безопасного входа за минуты.',
    breadcrumb: {
      resources: 'Ресурсы',
      getStarted: 'Начать',
    },
    hero: {
      badge: 'Быстрое Руководство по Настройке',
      title: 'Начните с',
      titleAccent: 'аутентификацией email/пароля',
      description: 'Добавьте безопасный вход по email/паролю с JWT токенами в ваше приложение за минуты. Следуйте нашему простому руководству по настройке и вы будете работать с надежной аутентификацией очень быстро.',
      createAccount: 'Создать Бесплатный Аккаунт',
    },
    steps: {
      title: 'Три простых шага к безопасной аутентификации по email/паролю',
      subtitle: 'Следуйте этим шагам для интеграции конечных точек аутентификации AuthFlow™ /auth в ваши backend приложения.',
      step1: {
        number: '1',
        title: 'Создайте Ваш Аккаунт',
        description: 'Зарегистрируйтесь в AuthFlow™ и создайте ваш первый проект. Вы получите ваш серверный API ключ мгновенно для безопасной аутентификации по email/паролю.',
        signUp: 'Зарегистрироваться Бесплатно',
        viewDemo: 'Посмотреть Демо',
      },
      step2: {
        number: '2',
        title: 'Интегрируйте Конечные Точки Auth',
        description: 'Используйте наши конечные точки /auth из вашего backend для обработки аутентификации пользователей. Все конечные точки требуют API ключ вашей организации для безопасного входа по email/паролю.',
        features: {
          apiKeyRequired: 'Требуется API Ключ',
          apiKeyDescription: 'Все конечные точки /auth требуют API ключ вашей организации в JWT токенах для безопасной аутентификации по email/паролю',
          backendIntegration: 'Backend Интеграция',
          backendDescription: 'Вызывайте из вашего серверного кода, никогда не раскрывайте API ключи во frontend',
          sessionManagement: 'Управление Сессиями',
          sessionDescription: 'Обрабатывайте сессии пользователей с JWT токенами, содержащими org API ключ для надежной аутентификации по email/паролю',
        },
      },
      step3: {
        number: '3',
        title: 'Добавьте Аутентификацию',
        description: 'Оберните ваше приложение вашим провайдером и начните использовать компоненты аутентификации. Это так просто с надежной аутентификацией по email/паролю!',
        quickStart: 'Быстрый Старт',
        fullDocumentation: 'Полная Документация',
      },
    },
    apiDocs: {
      title: 'Техническое Руководство по Конечным Точкам API /auth для Аутентификации Email/Пароль',
      subtitle: 'Полная техническая документация для интеграции конечных точек аутентификации AuthFlow™ по email/паролю в ваши backend приложения.',
      apiKeySetup: {
        title: 'Конфигурация API Ключа',
        description: 'API ключ вашей организации встроен во все JWT токены для конечных точек /auth. Храните это securely в переменных окружения вашего backend для надежной аутентификации по email/паролю.',
        envVars: '# Переменные Окружения',
        apiKeyVar: 'AUTHFLOW_API_KEY=af_your_api_key_here',
        baseUrlVar: 'AUTHFLOW_BASE_URL=https://api.authflow.net',
        securityNote: 'Примечание Безопасности: Никогда не раскрывайте ваш API ключ в frontend коде или клиентском JavaScript. Все вызовы конечных точек /auth должны выполняться из вашего backend сервера для безопасной аутентификации по email/паролю.',
      },
      endpoints: {
        foobar: {
          title: 'GET /auth/fooBar',
          description: 'Генерировать временные токены против злоупотреблений для потоков аутентификации',
          params: 'Параметры:',
          identityParam: 'identity (string): Email адрес пользователя',
          response: 'Ответ:',
          example: 'Пример Node.js:',
        },
        signUp: {
          title: 'POST /auth/signUp',
          description: 'Создавать новые учетные записи пользователей в вашей организации',
          params: 'Параметры:',
          foobarParam: 'foobar (string): Токен из /auth/fooBar',
          apiKeyParam: 'api_key (string): API ключ вашей организации',
          emailParam: 'email (string): Email адрес пользователя',
          passwordParam: 'password (string): Пароль пользователя (8-32 символов, заглавные, строчные, цифры, специальные символы)',
          fullnameParam: 'fullname (string): Полное имя пользователя',
          disclaimedParam: 'disclaimed (string): Должно быть "true"',
          response: 'Ответ:',
          example: 'Пример Node.js:',
        },
        login: {
          title: 'POST /auth/login',
          description: 'Аутентифицировать пользователей и получать токены сессий',
          params: 'Параметры:',
          foobarParam: 'foobar (string): Токен из /auth/fooBar',
          emailParam: 'email (string): Email адрес пользователя',
          passwordParam: 'password (string): Пароль пользователя',
          apiKeyParam: 'api_key (string): Organization API key',
          response: 'Ответ:',
          tokenNote: 'JWT содержит контекст аутентифицированного пользователя',
          example: 'Пример Node.js:',
        },
        validate: {
          title: 'GET /auth/validate',
          description: 'Валидировать токены сессий пользователей и проверять статус аутентификации',
          params: 'Параметры:',
          sessionTokenParam: 'sessionToken (string): JWT из /auth/login',
          emailParam: 'email (string): Email адрес пользователя',
          response: 'Ответ:',
          example: 'Пример Node.js:',
        },
        changePassword: {
          title: 'POST /auth/changePassword',
          description: 'Позволять аутентифицированным пользователям изменять их пароли',
          params: 'Параметры:',
          sessionTokenParam: 'sessionToken (string): JWT из /auth/login',
          emailParam: 'email (string): Email адрес пользователя',
          newPasswordParam: 'newPassword (string): Новый пароль (те же требования сложности)',
          response: 'Ответ:',
          example: 'Пример Node.js:',
        },
        logout: {
          title: 'GET /auth/logout',
          description: 'Завершать сессии пользователей securely',
          params: 'Параметры:',
          sessionTokenParam: 'sessionToken (string): JWT из /auth/login',
          emailParam: 'email (string): Email адрес пользователя',
          response: 'Ответ:',
          example: 'Пример Node.js:',
        },
      },
      implementation: {
        title: 'Полный Пример Backend Интеграции',
        notes: 'Примечания по Реализации:',
        note1: 'Храните токены сессий securely (рекомендуются HTTP-only cookies)',
        note2: 'Валидируйте сессии на защищенных маршрутах перед обработкой запросов',
        note3: 'Обрабатывайте истечение токенов и обновление по необходимости',
        note4: 'Логируйте события аутентификации для мониторинга безопасности',
      },
      errorHandling: {
        title: 'Обработка Ошибок и Безопасность',
        statusCodes: 'Общие HTTP Коды Статуса:',
        status200: '200: Успешно',
        status400: '400: Плохой Запрос (отсутствующие/невалидные параметры)',
        status401: '401: Неавторизован (невалидные токены, неправильный API ключ, etc.)',
        status404: '404: Пользователь не найден',
        status409: '409: Организация уже существует (регистрация)',
        status500: '500: Ошибка сервера',
        securityPractices: 'Лучшие Практики Безопасности:',
        practice1: 'Всегда валидируйте JWT токены перед обработкой запросов',
        practice2: 'Используйте HTTPS для всех API вызовов',
        practice3: 'Реализуйте ограничение скорости на конечных точках аутентификации',
        practice4: 'Храните токены сессий в HTTP-only, secure cookies',
        practice5: 'Логируйте все попытки аутентификации для мониторинга безопасности',
        practice6: 'Никогда не логируйте чувствительные данные вроде паролей или API ключей',
        criticalNote: 'Критично: Все конечные точки /auth должны вызываться только из вашего backend сервера. Никогда не раскрывайте ваш API ключ или выполняйте эти вызовы из клиентского JavaScript, так как это скомпрометирует безопасность вашей организации.',
      },
    },
    features: {
      title: 'Что вы получаете out-of-the-box с аутентификацией по email/паролю',
      subtitle: 'Подключите конечные точки, мы предоставляем вам Сессии с надежными JWT токенами. Это так просто! 🤝',
    },
    cta: {
      title: 'Готовы добавить надежную аутентификацию по email/паролю?',
      description: 'Начните ваш бесплатный тест сегодня, получите JWT аутентификацию работающей к концу дня.',
      createAccount: 'Создать Бесплатный Аккаунт',
      talkToSales: 'Поговорить с Продажами',
    },
    parameters: 'Параметры',
    response: 'Ответ',
    example: 'Пример',
    runFailureScenario: 'Запустить как сценарий ошибки',
    failureScenarioOn: 'Сценарий ошибки: Вкл',
    running: 'Выполняется...',
    runCurlConsole: 'Запустить cURL в консоли',
    copied: 'Скопировано!',
    copyCurl: 'Скопировать curl',
    copyBackendExample: 'Скопировать код бэкэнда',
    required: 'обязательно',
    optional: 'опционально',
    consoleRunning: 'Консоль выполняется...',
    consoleDemoTitle: 'Демо Linux-консоли',
    consoleShellLabel: 'bash -- Консоль AuthFlow™',
    notesTitle: 'Примечания',
    endpointContent: {
      session: {
        fooBar: {
          summary: 'Сгенерировать краткоживущий anti-abuse токен перед регистрацией или входом.',
          params: {
            identity: 'Email-адрес пользователя аутентификации.',
            apiKey: 'API-ключ организации из панели владельца AuthFlow™.',
            role: 'Роль RBAC, кодируемая во временный токен. По умолчанию: user.',
          },
          notes: {
            expires: 'Этот токен истекает через 45 секунд.',
            freshToken: 'Запрашивайте новый anti-abuse токен fooBar непосредственно перед регистрацией или входом.',
          },
        },
        signUp: {
          summary: 'Создать нового пользователя аутентификации в организации владельца.',
          params: {
            foobar: 'Временный anti-abuse токен, возвращаемый /auth/fooBar.',
            email: 'Email-адрес пользователя.',
            password: 'Пароль, соответствующий {passwordRule}.',
            fullname: 'Полное имя пользователя аутентификации.',
            role: 'Роль RBAC пользователя в вашем приложении.',
            apiKey: 'API-ключ организации.',
            disclaimed: 'Булевое значение, сохраняемое в записи пользователя. В коллекции используется true.',
          },
          notes: {
            successToken: 'При успешной регистрации сразу возвращается токен сессии.',
            duplicateRole: 'Если в вашей организации уже существует тот же email и роль, API вернет payload 409.',
          },
        },
        login: {
          summary: 'Аутентифицировать пользователя и вернуть либо токен сессии, либо 2FA-челлендж.',
          params: {
            foobar: 'Временный anti-abuse токен, возвращаемый /auth/fooBar.',
            email: 'Email-адрес пользователя.',
            password: 'Пароль пользователя.',
            apiKey: 'API-ключ организации.',
            role: 'Роль пользователя для RBAC-входа.',
          },
          notes: {
            tempTokenInsteadOfToken: 'Если 2FA включен, login возвращает tempToken вместо token.',
            exchangeThrough2fa: 'Далее tempToken обменивается через один из endpoint-ов верификации /auth/2fa.',
          },
        },
        validate: {
          summary: 'Проверить токен сессии пользователя аутентификации.',
          params: {
            sessionToken: 'Сессионный JWT-токен RS512.',
            email: 'Email-адрес пользователя.',
          },
        },
        me: {
          summary: 'Вернуть текущий профиль auth-пользователя для валидной сессии.',
          params: {
            sessionToken: 'Сессионный JWT-токен RS512.',
          },
        },
        logout: {
          summary: 'Выйти из текущей сессии auth-пользователя.',
          params: {
            sessionToken: 'Сессионный JWT-токен RS512.',
            email: 'Email-адрес пользователя.',
          },
        },
      },
      passwordManagement: {
        forgotPassword: {
          summary: 'Запросить email для сброса пароля пользователя (без утечки факта существования аккаунта).',
          params: {
            email: 'Email-адрес auth-пользователя.',
            apiKey: 'API-ключ организации.',
            role: 'Роль auth-пользователя. По умолчанию: user.',
          },
        },
        resetPassword: {
          summary: 'Сбросить пароль auth-пользователя с валидным токеном сброса.',
          params: {
            token: 'Токен сброса пароля из email-ссылки.',
            newPassword: 'Новый пароль, соответствующий {passwordRule}.',
          },
        },
        changePassword: {
          summary: 'Изменить пароль аутентифицированного auth-пользователя.',
          params: {
            sessionToken: 'Текущий сессионный JWT-токен RS512.',
            email: 'Email, закодированный в сессионном токене.',
            oldPassword: 'Текущий пароль для подтверждения.',
            newPassword: 'Новый пароль, соответствующий {passwordRule}.',
          },
        },
      },
      emailVerification: {
        verifyEmail: {
          summary: 'Подтвердить email auth-пользователя с помощью токена из письма AuthFlow™.',
          params: {
            token: 'Токен подтверждения из ссылки в письме.',
          },
          notes: {
            openedFromEmail: 'Обычно этот endpoint открывается по клику на ссылку подтверждения в письме.',
            frontendHostedProxy: 'AuthFlow™ также поддерживает frontend-hosted верификацию через /verify-email, которая проксирует эту проверку.',
          },
        },
        resendVerifyEmail: {
          summary: 'Повторно отправить письмо подтверждения, если аккаунт еще не подтвержден.',
          params: {
            foobar: 'Временный токен, возвращаемый /auth/fooBar.',
            email: 'Email-адрес auth-пользователя.',
            apiKey: 'API-ключ организации.',
            role: 'Роль auth-пользователя. По умолчанию: user.',
          },
        },
      },
      twoFactor: {
        enable: {
          summary: 'Сгенерировать TOTP-секрет и QR-код для auth-пользователя.',
          params: {
            sessionToken: 'Текущий токен сессии.',
            email: 'Email auth-пользователя.',
            apiKey: 'UUID организации.',
            role: 'Роль auth-пользователя.',
          },
        },
        verifySetup: {
          summary: 'Проверить начальный TOTP-код и включить 2FA.',
          params: {
            sessionToken: 'Текущий токен сессии.',
            email: 'Email auth-пользователя.',
            apiKey: 'UUID организации.',
            role: 'Роль auth-пользователя.',
            totpCode: 'Шестизначный код из приложения-аутентификатора.',
            secret: 'TOTP-секрет, возвращаемый /auth/2fa/enable.',
          },
        },
        disable: {
          summary: 'Отключить TOTP 2FA для auth-пользователя.',
          params: {
            sessionToken: 'Текущий токен сессии.',
            email: 'Email auth-пользователя.',
            apiKey: 'UUID организации.',
            role: 'Роль auth-пользователя.',
            password: 'Текущий пароль.',
          },
        },
        verify2fa: {
          summary: 'Обменять tempToken входа и TOTP-код на токен сессии.',
          params: {
            tempToken: 'tempToken, возвращаемый /auth/login при включенном 2FA.',
            email: 'Email auth-пользователя.',
            apiKey: 'UUID организации.',
            role: 'Роль auth-пользователя.',
            totpCode: 'Шестизначный код аутентификатора.',
          },
        },
        backupEmail: {
          summary: 'Отправить резервный email OTP с использованием tempToken входа.',
          params: {
            tempToken: 'tempToken, возвращаемый /auth/login.',
            email: 'Email auth-пользователя.',
            apiKey: 'UUID организации.',
            role: 'Роль auth-пользователя.',
          },
        },
        verifyEmailOtp: {
          summary: 'Обменять OTP из email на токен сессии.',
          params: {
            email: 'Email auth-пользователя.',
            apiKey: 'UUID организации.',
            role: 'Роль auth-пользователя.',
            emailOtp: 'Шестизначный код, доставленный по email.',
          },
        },
        recoveryCodes: {
          summary: 'Перегенерировать коды восстановления для auth-пользователя.',
          params: {
            sessionToken: 'Текущий токен сессии.',
            email: 'Email auth-пользователя.',
            apiKey: 'UUID организации.',
            role: 'Роль auth-пользователя.',
            password: 'Текущий пароль.',
          },
        },
        verifyRecovery: {
          summary: 'Обменять код восстановления на токен сессии.',
          params: {
            email: 'Email auth-пользователя.',
            apiKey: 'UUID организации.',
            role: 'Роль auth-пользователя.',
            recoveryCode: 'Один из ранее выданных 8-символьных кодов восстановления.',
          },
        },
      },
      environment: {
        baseUrl: 'Публичный origin API.',
        apiKey: 'API-ключ из панели владельца. Хранится только на сервере.',
        defaultRole: 'Значение роли/RBAC, которое вы назначаете auth-пользователю.',
      },
    },
    console: {
      promptPrefix: 'owner@authflow-demo:~$',
      launching: 'Запуск Linux Console AuthFlow™ v1.0 ...',
      kernel: 'Ядро: Linux 6.8.0-35-generic x86_64',
      curlVersion: 'curl: 8.5.0, OpenSSL: 3.0.x',
      connected: 'Подключено к api.authflow.net',
      sending: '> Отправка {method} {path}',
      waiting: '> Ожидание ответа ...',
      serverHeader: '< server: api.authflow.net',
      processExited: '[процесс завершен с кодом {code}]',
      status: {
        defaultSuccess: 'HTTP/1.1 200 OK (пример)',
        signup: {
          success: 'HTTP/1.1 201 Created (пример)',
          alt409: '# alt: HTTP/1.1 409 Conflict, когда email+role уже существуют',
        },
        login: {
          success: 'HTTP/1.1 200 OK (пример)',
          alt2fa: '# alt: возвращает requires2FA/tempToken payload при включенном 2FA',
        },
        verifyEmail: {
          success: 'HTTP/1.1 200 OK (пример)',
          alt401: '# alt: HTTP/1.1 401 Unauthorized для невалидного или истекшего токена подтверждения',
        },
        validate: {
          success: 'HTTP/1.1 200 OK (пример)',
          alt401: '# alt: HTTP/1.1 401 Unauthorized для невалидного или истекшего сессионного токена',
        },
        forgotPassword: {
          success: 'HTTP/1.1 200 OK (безопасный ответ против enumeration)',
        },
        changePassword: {
          success: 'HTTP/1.1 200 OK (пример)',
          noJsonBody: '# при успехе JSON-тело отсутствует',
        },
      },
      failure: {
        signup: {
          status: 'HTTP/1.1 409 Conflict (пример)',
          extra: '# сценарий ошибки: дублирующийся email+role',
        },
        login: {
          status: 'HTTP/1.1 400 Bad Request (пример)',
          extra: '# сценарий ошибки: неверные учетные данные или несовпадение роли',
        },
        verifyEmail: {
          status: 'HTTP/1.1 401 Unauthorized (пример)',
          extra: '# сценарий ошибки: устаревший токен подтверждения',
        },
        validate: {
          status: 'HTTP/1.1 401 Unauthorized (пример)',
          extra: '# сценарий ошибки: истекший токен сессии',
        },
        me: {
          status: 'HTTP/1.1 401 Unauthorized (пример)',
          extra: '# сценарий ошибки: отсутствует или невалиден sessionToken',
        },
        logout: {
          status: 'HTTP/1.1 401 Unauthorized (пример)',
          extra: '# сценарий ошибки: невалидный sessionToken',
        },
        changePassword: {
          status: 'HTTP/1.1 401 Unauthorized (пример)',
          extra: '# сценарий ошибки: oldPassword неверный или сессия истекла',
        },
        resendVerifyEmail: {
          status: 'HTTP/1.1 401 Unauthorized (пример)',
          extra: '# сценарий ошибки: устаревший foobar-токен или невалидный api_key',
        },
        fooBar: {
          status: 'HTTP/1.1 400 Bad Request (пример)',
          extra: '# сценарий ошибки: отсутствует identity или api_key',
        },
        forgotPassword: {
          status: 'HTTP/1.1 400 Bad Request (пример)',
          extra: '# сценарий ошибки: отсутствует email или api_key',
        },
        resetPassword: {
          status: 'HTTP/1.1 401 Unauthorized (пример)',
          extra: '# сценарий ошибки: устаревший reset token',
        },
        default: {
          status: 'HTTP/1.1 400 Bad Request (пример)',
          extra: '# сценарий ошибки',
        },
      },
    },
    pageContent: {
      badge: 'Справочник по продукту аутентификации',
      title: 'Документация API AuthFlow™',
      titleAccent: 'для владельцев организаций',
      description: 'Этот раздел Get Started документирует наш публичный auth API для пользователей вашей организации. AuthFlow™ предоставляет 20 маршрутов /auth: 7 маршрутов session для аутентификации и управления пользователями, 3 маршрута passwordManagement для сброса пароля, 2 маршрута emailVerification для подтверждения email и 8 маршрутов twoFactor для двухфакторной аутентификации. Загружаемая ниже коллекция Insomnia содержит все определения эндпоинтов, параметры и примеры запросов, соответствующие точным контрактам API.',
      downloadCollection: 'Скачать коллекцию Insomnia',
      createAccount: 'Создать аккаунт владельца',
      cloneStarterOnGitHub: 'Клонировать стартер Next.js',
      starterInfoLabel: 'Важная информация о безопасности стартера Next.js',
      starterWarningTitle: 'Только для прототипов и проверки концепции',
      starterWarningPrototype: 'authflow-nextjs-starter предназначен исключительно для прототипов и интерфейсов для проверки концепции. Это не браузерная интеграция для промышленной эксплуатации.',
      starterWarningSecret: 'Никогда не размещайте API-ключ AuthFlow в промышленном frontend-коде, видимых браузеру переменных окружения, статических ресурсах или клиентских пакетах. Всё, что отправляется в браузер, могут прочитать пользователи и злоумышленники.',
      starterWarningProduction: 'В промышленной среде отправляйте запросы аутентификации через доверенный серверный backend или прокси AuthFlow ExpressJS, а API-ключ храните в серверных переменных окружения или управляемом хранилище секретов.',
      apiKeyWarningTitle: 'Никогда не раскрывайте API-ключ AuthFlow в промышленном браузерном коде.',
      apiKeyWarningBody: 'API-ключи должны оставаться в контролируемой вами инфраструктуре. Не встраивайте их в пакеты JavaScript, HTML, общедоступные переменные окружения, мобильные веб-ресурсы, журналы или сетевые запросы непосредственно из браузера. Используйте этот прокси ExpressJS или собственный backend, чтобы ключ оставался на сервере.',
      integrationRulesTitle: 'Правила интеграции',
      integrationRulesRules: [
        'Владельцы организаций должны вызывать AuthFlow™ только из серверного кода. В браузерных приложениях секреты должны храниться как серверные переменные окружения для вызова AuthFlow™ API. Причина в том, что, в отличие от большинства сервисов аутентификации, AuthFlow™ спроектирован для server-to-server использования и общего соответствия стандартам NIST.',
        'API-ключ владельца организации (ваш) обязателен для ключевых маршрутов управления сессиями и других маршрутов.',
        'Токен fooBar является краткоживущим anti-abuse токеном и должен запрашиваться непосредственно перед каждой попыткой регистрации или входа, чтобы он всегда был свежим и валидным.',
        'Если login возвращает requires2FA (то есть пользователь включил 2FA), пользователь должен завершить один из задокументированных /auth/2fa обменов подтверждения, чтобы получить сессионный токен.',
      ],
      ownerAssetsTitle: 'Ресурсы владельца',
      ownerAssetsText: 'Используйте точную коллекцию, которую ваша команда внедрения может импортировать в Insomnia.',
      ownerAssetsCollectionName: 'AuthFlow_Consumers.yaml',
      collectionIncludes: 'Коллекция включает:',
      collectionItems: [
        '7 публичных маршрутов /auth session',
        '3 публичных маршрута /auth passwordManagement',
        '2 публичных маршрута /auth emailVerification',
        '8 публичных маршрутов /auth/2fa twoFactor',
        'Переменные окружения для API-ключа, роли/RBAC, сессионного токена, TOTP, временного токена и сценариев с кодами восстановления',
      ],
      checklistTitle: 'Чеклист внедрения',
      checklistSubtitle: 'Это рекомендуемый рабочий процесс для владельца организации по подключению аутентификации вашей организации через AuthFlow™.',
      configStep: '1. Настройте серверные секреты',
      implementStep: '2. Реализуйте серверную аутентификацию',
      connectStep: '3. Подключите фронтенд',
      connectStepSecurityNote: 'Ваш браузерный код никогда не должен хранить секреты API AuthFlow™, включая API-ключ владельца.',
      implementStepRules: [
        'Запросите /auth/fooBar',
        'Вызовите /auth/signUp или /auth/login',
        'Безопасно храните сессионные токены',
        'Используйте /auth/validate, /auth/me, /auth/changePassword и /auth/logout из защищенных маршрутов',
      ],
      connectStepRules: [
        'Отправляйте формы входа и регистрации',
        'Обрабатывайте запросы 2FA, когда API сообщает requires2FA',
        'Храните сессии приложения в защищенных cookie',
        'Загружайте текущего пользователя через ответы session-эндпоинтов',
      ],
      sessionEndpointsTitle: 'Эндпоинты сессий',
      sessionEndpointsSubtitle: 'Эти семь маршрутов соответствуют authProduct.session из корневого backend-эндпоинта.',
      passwordMgmtTitle: 'Эндпоинты управления паролем',
      passwordMgmtSubtitle: 'Эти три маршрута соответствуют authProduct.passwordManagement из корневого backend-эндпоинта.',
      emailVerificationTitle: 'Эндпоинты подтверждения email',
      emailVerificationSubtitle: 'Эти два маршрута соответствуют authProduct.emailVerification из корневого backend-эндпоинта.',
      twoFactorTitle: 'Эндпоинты двухфакторной аутентификации',
      twoFactorSubtitle: 'Эти восемь маршрутов соответствуют authProduct.twoFactor из корневого backend-эндпоинта.',
      serviceExampleTitle: 'Пример сервиса',
      securityRequirementsTitle: 'Требования безопасности',
      securityRequirements: [
        'Храните AUTHFLOW_API_KEY на стороне сервера и в зашифрованном виде.',
        'Предпочитайте безопасные HTTP-only cookie для сессий приложения.',
        'Проверяйте сессии AuthFlow™ перед выдачей защищенных пользовательских данных.',
        'Явно обрабатывайте ответы 400, 401, 404, 409 и 500 в вашей интеграции.',
      ],
      readyCtaTitle: 'Готовы подключить аутентификацию вашей компании?',
      readyCtaDescription: 'Начните с загружаемой коллекции, реализуйте безопасную интеграцию сервиса с надежно хранимыми секретами и используйте ассистента на этой странице, если нужна помощь.',
      proxyTitlePrefix: 'ExpressJS ',
      proxyTitleSuffix: ' Прокси',
      proxyDescriptionPrefix: 'Вы также можете проксировать backend AuthFlow из собственного backend на ExpressJS. Это, пожалуй, самый безопасный способ использовать ',
      proxyDescriptionSuffix: ' в ваших стэках приложений.',
      proxyDetailsRoutes: 'Прокси перенаправляет все маршруты AuthFlow /auth/* и /auth/2fa/*, хранит API-ключ вашей организации на сервере и помогает предотвратить утечку секретов в браузерном коде.',
      proxyDetailsDeploy: 'Прокси готов к деплою на Vercel, сразу поддерживает локальную разработку и включает практические примеры для регистрации, входа, восстановления пароля и проверки 2FA.',
      proxyButton: 'Открыть на GitHub',
    },
  },

  agent: {
    chatbot: {
      title: 'Ассистент AuthFlow™',
      inputPlaceholder: 'Спросите про интеграцию /auth или 2FA...',
      greeting: 'Я помогаю владельцам организаций по точному контракту AuthFlow™ auth-user. Спросите про owner API key, endpoint-ы /auth, потоки 2FA, коллекцию Insomnia, границы frontend-backend или удаление аккаунта в Settings.',
      downloadIntro: 'Используйте эту карточку прямой загрузки, чтобы сразу получить owner-коллекцию для импорта.',
      downloadTitle: 'Скачать коллекции Insomnia',
      downloadButton: 'Скачать',
      noAnswer: 'Я не получил пригодный ответ от агента. Спросите про конкретный endpoint, 2FA-поток или шаг backend-интеграции.',
      error: 'Ошибка при обращении к ассистенту. Вы можете снова спросить про контракт /auth, 2FA-потоки или коллекцию Insomnia.',
      toolNotFound: 'Инструмент не найден',
    },
    tools: {
      verificationRecoveryDescription: 'Эндпоинты верификации email и восстановления пароля',
      accountSteps: ['1. Зарегистрируйтесь как владелец на https://www.authflow.net/sign-up', '2. Создайте организацию в owner dashboard', '3. Скопируйте API key организации', '4. Определите значения role для auth-пользователей', '5. Скачайте коллекцию AuthFlow™ auth-user для Insomnia', '6. Передайте коллекцию и точный backend-контракт команде интеграции'],
      accountManagement: ['Для полного удаления организации откройте Settings в AuthFlow™ dashboard.', 'Используйте Delete Account и введите DELETE для подтверждения.'],
      reminder: 'Owner API key должен храниться только на backend компании.',
      environmentNotes: ['Храните AUTHFLOW_API_KEY только на сервере.', 'AUTHFLOW_DEFAULT_ROLE опционален, но полезен.', 'Frontend должен вызывать ваш backend, а не AuthFlow™ напрямую.'],
      backendGuidance: ['Запрашивайте /auth/fooBar непосредственно перед /auth/signUp или /auth/login.', 'Используйте точные имена параметров публичного контракта.', 'Если /auth/login вернул requires2FA, продолжайте через соответствующий /auth/2fa endpoint.', 'Проверяйте и загружайте пользователя через backend-маршруты, отдавая во frontend только сессию приложения.'],
      insomniaContains: ['Все 12 публичных endpoint-ов /auth (включая verify-email, resend-verify-email, forgot-password, reset-password, deleteUser)', 'Все 8 публичных endpoint-ов /auth/2fa', 'Переменные окружения для API key, role, fooBar token, tempToken, session token, TOTP, email OTP и recovery code flows'],
      troubleshoot: {
        solutions: {
          cors: 'Если браузер вызывает AuthFlow™ напрямую, остановитесь: браузер должен вызывать ваш backend.',
          '401_unauthorized': 'Проверьте api_key, role и email для /auth/fooBar и логина.',
          token_validation: 'Для /auth/validate используйте точную пару sessionToken + email; не путайте с tempToken.',
          connection_failed: 'Проверьте AUTHFLOW_BASE_URL = https://api.authflow.net и доступ backend к хосту.',
          api_key_invalid: 'Owner API key должна быть dashboard-ключом, начинающимся с af_.',
          foobar_expired: 'fooBar быстро истекает; запрашивайте его непосредственно перед sign-up/login.',
          verification_link: 'Токен подтверждения должен быть валиден и передан как query в /auth/verify-email.',
          password_reset: 'Сначала /auth/forgot-password, затем /auth/reset-password с токеном из email.',
          two_factor_flow: 'Если login вернул requires2FA, используйте tempToken только в /auth/2fa маршрутах.',
          organization_deletion: 'Удаление организации выполняется в Settings > Delete Account с вводом DELETE.',
          other: 'Сверьте запрос с публичным контрактом: параметры, HTTP метод и место передачи query/body/header.',
        },
        commonIssues: ['Frontend вызывает AuthFlow™ напрямую', 'Отсутствует api_key или неверный role в /auth/fooBar или /auth/login', 'Неверно переданы oldPassword/newPassword в /auth/changePassword', 'Путаница tempToken и sessionToken', 'Просроченный или неверный verification token', 'Не вызван /auth/forgot-password перед /auth/reset-password', 'Пропущен обмен 2FA после requires2FA', 'Попытка удалить организацию вне Settings flow'],
      },
    },
  },

  comparisons: {
    hub: {
      breadcrumbRoot: 'Сравнение',
      breadcrumbCurrent: 'Сравнение продуктов аутентификации',
      title: 'Сравнение продуктов аутентификации',
      description: 'Сравните AuthFlow™ с самыми популярными платформами аутентификации. Таблицы функций side-by-side помогут выбрать правильное auth-решение для вашего проекта.',
      card: {
        firebase: {
          title: 'Firebase vs. Auth0 vs. AuthFlow™',
          description: 'Сравните Firebase Authentication от Google, enterprise-платформу Auth0 и developer-first подход AuthFlow™. Так вы быстрее поймете, какое решение лучше подходит вашему стеку.',
        },
        supabase: {
          title: 'Supabase vs. Auth0 vs. AuthFlow™',
          description: 'Сравните open-source аутентификацию Supabase, enterprise-предложение Auth0 и легкий, сфокусированный сервис AuthFlow™. Особенно полезно, если вы уже в экосистеме Supabase.',
        },
      },
      bullets: {
        core: 'Базовые auth-функции и безопасность',
        rbac: '2FA, RBAC и мультиарендность',
        supabaseModel: 'Open source vs. managed vs. focused',
        pricing: 'Цена и vendor lock-in',
        dx: 'Developer experience и сложность настройки',
      },
      viewComparison: 'Смотреть сравнение',
    },
    labels: {
      fullySupported: 'Полностью поддерживается',
      partial: 'Частично / ограниченно',
      notSupported: 'Не поддерживается',
      feature: 'Функция',
      summary: 'Итог',
      startFree: 'Начать бесплатно с AuthFlow™',
      alsoSee: 'Смотрите также:',
      providers: {
        firebase: 'Firebase Auth',
        supabase: 'Supabase Auth',
        auth0: 'Auth0',
        authflow: 'AuthFlow™',
      },
      categories: {
        core: 'Базовая аутентификация',
        security: 'Безопасность',
        userOrg: 'Пользователи и организации',
        dx: 'Developer Experience',
        pricing: 'Цена и гибкость',
      },
    },
    features: {
      emailPassword: 'Аутентификация по email и паролю',
      socialLogin: 'Social login (Google, GitHub и др.)',
      magicLinks: 'Magic Links / без пароля',
      smsPhone: 'SMS / телефонная аутентификация',
      anonymous: 'Анонимная аутентификация',
      jwt: 'Управление JWT-токенами',
      rs512: 'Подпись ключевой парой RS512',
      twofa: 'Двухфакторная аутентификация (2FA)',
      totp: 'TOTP-приложение (Google Auth, Authy)',
      backupCodes: 'Резервные коды 2FA',
      emailOtp: '2FA через email OTP',
      rateLimiting: 'Rate limiting',
      emailVerification: 'Подтверждение email',
      passwordReset: 'Сброс пароля / забыли пароль',
      passwordComplexity: 'Политики сложности пароля',
      userDashboard: 'Панель управления пользователями',
      rbac: 'Управление доступом по ролям (RBAC)',
      multiTenancy: 'Мультиарендность / Организации',
      perOrgApiKeys: 'API-ключи на организацию',
      auditLogs: 'Журналы аудита/активности',
      userBlocking: 'Блокировка / приостановка пользователя',
      simpleRest: 'Простое REST API (без обязательного SDK)',
      officialSdks: 'Официальные клиентские SDK',
      customEmailTemplates: 'Кастомные email-шаблоны',
      webhooks: 'Webhooks / callbacks событий',
      selfHosted: 'Self-hosted вариант',
      openSource: 'Открытый исходный код',
      apiDocs: 'API-документация',
      integratedDb: 'Интегрированная БД (PostgreSQL)',
      authOnly: 'Только auth (без обязательной БД)',
      freeTier: 'Есть бесплатный тариф',
      flatRate: 'Предсказуемая фиксированная цена',
      payPerMau: 'Модель оплаты за MAU',
      lowLockIn: 'Низкий vendor lock-in',
      lowSetup: 'Низкая сложность настройки',
      noEcosystemBuyIn: 'Работает без привязки к экосистеме',
    },
    notes: {
      firebase2fa: 'Для 2FA в Firebase обычно требуется переход на Identity Platform.',
      firebaseRest: 'Firebase ориентирован на SDK; при использовании чистого REST нужен ручной обмен токенами.',
      firebaseLockIn: 'Firebase сильно привязан к экосистеме Google/Firebase.',
      supabaseRls: 'Supabase использует политики Row-Level Security (RLS) в Postgres.',
      supabaseDb: 'Supabase Auth тесно интегрирован с базой данных Postgres в Supabase.',
      supabaseLockIn: 'Open source снижает lock-in, но auth-слой Supabase все равно связан с его Postgres-стеком.',
      supabaseAuthOnly: 'Supabase можно использовать только для auth, но он спроектирован как полноценная backend-платформа.',
    },
    firebase: {
      breadcrumbCurrent: 'Firebase vs. Auth0 vs. AuthFlow™',
      title: 'Firebase vs. Auth0 vs. AuthFlow™',
      description: 'Сравнение функций Google Firebase Authentication, Okta Auth0 и AuthFlow™ в формате side-by-side, чтобы вы могли выбрать правильный auth-слой для вашего приложения.',
      summary: {
        firebaseTitle: 'Firebase Authentication',
        firebaseBody: 'Лучше всего подходит командам, уже работающим в экосистеме Google/Firebase. Есть щедрый бесплатный тариф и удобная SDK-first интеграция, но присутствует lock-in и для продвинутых функций вроде 2FA обычно нужен Identity Platform.',
        auth0Title: 'Auth0',
        auth0Body: 'Самый полный набор функций из трех: SAML, OIDC, enterprise SSO и глубокая кастомизация. Отлично для крупных команд со сложными enterprise-требованиями, но стоимость заметно растет с MAU.',
        authflowTitle: 'AuthFlow™',
        authflowBody: 'Подходящий выбор для команд, которым нужна надежная email/password аутентификация с сильной безопасностью (RS512 JWT, 2FA, RBAC) без привязки к большому экосистемному вендору. Простое REST API, предсказуемая цена и низкая сложность внедрения.',
      },
      alsoSee: 'Supabase vs. Auth0 vs. AuthFlow™',
    },
    supabase: {
      breadcrumbCurrent: 'Supabase vs. Auth0 vs. AuthFlow™',
      title: 'Supabase vs. Auth0 vs. AuthFlow™',
      description: 'Сравнение open-source auth от Supabase, enterprise-платформы Auth0 и AuthFlow™ в формате side-by-side, чтобы вы могли выбрать правильный auth-слой для вашего приложения.',
      summary: {
        supabaseTitle: 'Supabase Auth',
        supabaseBody: 'Отлично подходит командам, которым нужен open-source backend с возможностью self-hosting. Supabase Auth мощный, поддерживает social login, magic links и глубокую интеграцию с Postgres. Особенно хорош, если вы уже используете Supabase как базу данных.',
        auth0Title: 'Auth0',
        auth0Body: 'Самый комплексный набор возможностей: SAML, OIDC, enterprise SSO и гибкая кастомизация. Частый выбор больших команд со сложными требованиями комплаенса, но стоимость быстро растет с количеством активных пользователей в месяц.',
        authflowTitle: 'AuthFlow™',
        authflowBody: 'Оптимальный выбор, когда нужна сфокусированная и надежная email/password аутентификация с сильной безопасностью (RS512 JWT, 2FA, RBAC) и без платформенного lock-in. Простое REST API, предсказуемая фиксированная цена и минимальный setup.',
      },
      alsoSee: 'Firebase vs. Auth0 vs. AuthFlow™',
    },
  },

  // Common
  common: {
    loading: 'Загрузка...',
    error: 'Произошла ошибка',
    success: 'Успех',
    cancel: 'Отмена',
    save: 'Сохранить',
    delete: 'Удалить',
    edit: 'Редактировать',
    view: 'Просмотреть',
    back: 'Назад',
    next: 'Далее',
    previous: 'Предыдущий',
    language: 'Язык',
  },

  // SEO
  seo: {
    title: 'AuthFlow™ - Безопасная Аутентификация Сделана Просто',
    description: 'Аутентификация на основе токенов для веб-приложений. Легкая интеграция, корпоративная безопасность и удобный API для разработчиков. Начните бесплатный тест сегодня.',
    keywords: ['аутентификация', 'авторизация', 'безопасность', 'API', 'аутентификация по токенам', 'JWT', 'инструменты разработчика', 'безопасность веб', 'управление пользователями'],
  },

  // Footer (shared across pages)
  footer: {
    description: 'Простая, надежная аутентификация по email/паролю с JWT токенами. Доверяют разработчики по всему миру.',
    product: 'Продукт',
    resources: 'Ресурсы',
    company: 'Компания',
    apiReference: 'API Справочник',
    about: 'О Нас',
    support: 'Поддержка',
    privacyPolicy: 'Политика Конфиденциальности',
    termsOfService: 'Условия Использования',
    copyright: '© 2024 AuthFlow™. Все права защищены.',
  },
}
